import {
  arrayBufferFileLoader,
  type DocRenderer,
} from "@cyntler/react-doc-viewer";
import { useEffect, useRef } from "react";
import { tiffToCanvases } from "./tiffToCanvas";
import { wait } from "@repo/lib/wait";

export const TIFFRenderer: DocRenderer = ({
  mainState: { currentDocument },
}) => {
  const canvasesContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = canvasesContainer.current;
    if (!container || !currentDocument) return;

    let cancel = false;

    wait(100).then(() => {
      if (cancel) return;

      container.innerHTML = "";

      const canvases = tiffToCanvases(currentDocument.fileData as ArrayBuffer);

      for (const canvas of canvases) {
        canvas.style.maxWidth = "100%";
        canvas.style.marginBottom = "10px";
        container.appendChild(canvas);
      }
    });

    return () => {
      cancel = true;
    };
  }, [currentDocument]);

  if (!currentDocument) return null;

  return (
    <div ref={canvasesContainer}>
      <p className="w-full text-center m-4">Processing...</p>
    </div>
  );
};
TIFFRenderer.fileTypes = ["tif", "tiff", "image/tif", "image/tiff"];
TIFFRenderer.weight = 1;
TIFFRenderer.fileLoader = arrayBufferFileLoader;
